import ZoomedDiv from "../custom/ZoomedDiv";

export default function Gallery(): JSX.Element {
  return (
    //   <>
    //     {openZoom === false ? (
    //       <div className="App overflow-x-hidden">
    //       </div>
    //     ) : (
    //       <ZoomedDiv />
    //     )}
    //   </>
    <ZoomedDiv />
  );
}
